import React, { useCallback, useState, useEffect } from "react";

import { Modal, Form, Input, Upload, Button } from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import { openNotificationWithIcon } from "./Function";

export const ModelEditComment = ({
  editForm,
  editVisible,
  setEditVisible,
  editingItem,
  loadingEdit,
  putEditComment,
}) => {
  const [fileList, setFileList] = useState([]);
  const [oldFiles, setOldFiles] = useState([]); // các file đã upload trước đó
  const [removedOldFiles, setRemovedOldFiles] = useState([]); // [name, ...]

  useEffect(() => {
    setOldFiles(Object.entries(editingItem.att_file || {})); // giữ file cũ
    editForm.setFieldsValue({ content: editingItem.content });
  }, [editVisible]);



  return (
    <Modal
      title="Chỉnh sửa bình luận"
      open={editVisible}
      onCancel={() => {
        setEditVisible(false);
        editForm.resetFields();
      }}
      onOk={() => {
        editForm.validateFields().then((values) => {
          // Gửi dữ liệu lên server hoặc gọi callback
          const updatedComment = {
            comment_id: editingItem.id,
            content_comment: values.content,
            att_file: fileList,
            deleted_old_files: removedOldFiles,
          };

          putEditComment(updatedComment);
        });
      }}
      // confirmLoading={loadingEdit}
    >
      {/* <Spin spinning={loadingEdit}></Spin> */}
      <Form form={editForm} layout="vertical">
        <Form.Item
          name="content"
          label="Nội dung bình luận"
          rules={[{ required: true }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item label="File đính kèm mới">
          <Upload
            multiple
            beforeUpload={(file) => {
              // File tối đa 50MB
              const isTooLarge = file.size / 1024 / 1024 > 50;
              if (isTooLarge) {
                openNotificationWithIcon(
                  "error",
                  "Lỗi",
                  `File "${file.name}" vượt quá 50MB!`
                );
                return Upload.LIST_IGNORE; // NGĂN file bị thêm vào danh sách
              }

              setFileList((prev) => [...prev, file]);
              return false; // Ngăn Upload tự động
            }}
            onRemove={(file) => {
              setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
            }}
            fileList={fileList}
          >
            <Button icon={<UploadOutlined />}>Chọn file</Button>
          </Upload>
        </Form.Item>

        <Form.Item label="File đã đính kèm trước đó">
          {oldFiles && oldFiles.length > 0 ? (
            oldFiles.map(([name, url]) => (
              <div
                key={name}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <a href={url} download>
                  {name}
                </a>
                <DeleteOutlined
                  style={{ color: "red", cursor: "pointer" }}
                  onClick={() => {
                    setOldFiles((prev) =>
                      prev.filter(([fname]) => fname !== name)
                    );
                    // setRemovedOldFiles((prev) => [...prev, name, url]);
                    setRemovedOldFiles((prev) => [...prev, name]);
                  }}
                />
              </div>
            ))
          ) : (
            <p>Không có</p>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};
